import { SettlementStatusEnum } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  // SingleAction,
  Sort,
  TabActionDialog
} from "../../types";

const financeOrderSectionUrl = "/payout/finance-orders";
export enum FinanceOrderListUrlFiltersEnum {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  isPayoutEligible = "isPayoutEligible",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  paymentMethodType = "paymentMethodType",
  query = "query"
}

export enum FinanceOrderListUrlFiltersWithMultipleValuesEnum {
  deliveryType = "deliveryType",
  verticalType = "verticalType",
  mall = "mall",
  brand = "brand"
}
export const financeOrderListPath = financeOrderSectionUrl;

export type FinanceOrderListUrlFilters = Filters<
  FinanceOrderListUrlFiltersEnum
> &
  FiltersWithMultipleValues<
    FinanceOrderListUrlFiltersWithMultipleValuesEnum
  > & {
    payoutStatus?: SettlementStatusEnum;
  };
export type FinanceOrderListUrlDialog =
  | TabActionDialog
  | "download"
  | "exclude"
  | "for-payment"
  | "for-payment-express"
  | "generate-batch"
  | "onClickGenerateBatch"
  | "return"
  | "showAdjustmentDialog";

export enum FinanceOrderListUrlSortField {
  date = "date"
}

export type FinanceOrderListUrlSort = Sort<FinanceOrderListUrlSortField>;
export type FinanceOrderListUrlQueryParams = BulkAction &
  Dialog<FinanceOrderListUrlDialog> &
  FinanceOrderListUrlFilters &
  FinanceOrderListUrlSort &
  Pagination &
  ActiveTab & {
    id?: string;
    payoutStatus?: SettlementStatusEnum;
    // orderId?: string;
    // orderCode?: string;
    // orderStatus?: SmopOrderStatusEnum;
    // newOrderStatus?: SmopOrderStatusEnum;
    // courier?: string;
  };
export const financeOrderListUrl = (
  params?: FinanceOrderListUrlQueryParams
): string => {
  const financeOrderList = financeOrderListPath;
  if (params === undefined) {
    return urlJoin(
      financeOrderList,
      "?" + stringifyQs({ activeTab: 0, payoutStatus: "OPEN" })
    );
  } else {
    return urlJoin(financeOrderList, "?" + stringifyQs(params));
  }
};
